import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { instantItems } from '../../data/content';
export function InstantAccess() {
  return <section className="w-full bg-white px-4 py-14" data-id="element-170" data-mp="3ebrngcekz9tr">
      <div className="mx-auto w-full max-w-3xl" data-id="element-171" data-mp="39bdnzir1p87c">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-172" data-mp="39a2dz170b47s">
          What Do You Get Instantly?
        </h2>

        <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-173" data-mp="30ca62i3m6yuf">
          {instantItems.map(item => <li key={item.text} className="flex items-center gap-3 rounded-2xl bg-sand/70 px-4 py-3.5" data-id="element-174" data-mp="2vjqiqtf4kpcf">
              <span className="text-lg leading-none" aria-hidden="true" data-id="element-175" data-mp="2lmcdlpynjmzf">
                {item.emoji}
              </span>
              <span className="text-[14px] font-medium leading-snug text-ink" data-id="element-176" data-mp="2gnr9vgk6yl68">{item.text}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-xl text-center font-display text-lg italic leading-snug text-ink-soft" data-id="element-177" data-mp="2cm64shdwfb6l">
          Any complex case that walks into your clinic… you now have a structured way to handle
          it.
        </p>

        <SectionCTA headline="Download it today and use it on your next patient." data-id="element-178" data-mp="2vqiqq01ajpx4" />
      </div>
    </section>;
}